import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEmailSyncPotentialContacts,
    GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts as EmailSyncFoundContact,
} from 'nutshell-graphql-types';

import GET_EMAIL_SYNC_POTENTIAL_CONTACTS from '../queries/get-email-sync-potential-contacts.graphql';

type UseGetEmailSyncPotentialContactsResult = {
    contacts: EmailSyncFoundContact[];
    isLoading: boolean;
    error: string | null | undefined;
};

export function useGetEmailSyncPotentialContacts(): UseGetEmailSyncPotentialContactsResult {
    const {data, loading, error} = useQuery<GetEmailSyncPotentialContacts>(
        GET_EMAIL_SYNC_POTENTIAL_CONTACTS,
        {fetchPolicy: 'cache-and-network'}
    );

    return {
        contacts: data?.getEmailSyncPotentialContacts ?? [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
